import sanitize from 'sanitize-html'

const ALLOWED_TAGS = [
  'p',
  'br',
  'span',
  'b',
  'strong',
  'i',
  'em',
  'mark',
  'small',
  'del',
  'ins',
  'sub',
  'sup',
  'li',
  'ul',
  'ol',
  'u',
]

/**
 * Método que permite que você especifique as tags que deseja permitir em um conteúdo html.
 * @param {string} value
 */
export const allowedHtml = (value, allowedTags = ALLOWED_TAGS) => sanitize(value, { allowedTags })

/**
 * Método que descarta todo o conteúdo html.
 * @param {string} value
 */
export const clearHtml = value => sanitize(value, { allowedTags: [], allowedAttributes: {} })

/**
 * Método para contar a quantidade de caracteres de um texto.
 * @param {string} value
 */
export const countCharactersWSpace = value => value.replace(/\n/g, '').length
